import { Text, CloseIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './header.module.css'

import type { FinanceProfileHeaderProps } from './header.type'

export const FinanceProfileHeader = ({
  onHandleOpen,
}: FinanceProfileHeaderProps) => {
  const { t } = useTranslation('componentsFinanceProfileForm')

  return (
    <header className={styles.header}>
      <div className={styles['header-box-content']}>
        <Text className={styles['header-title']} variant="title-large">
          {t('headerTitle')}
        </Text>

        <Text className={styles['header-subtitle']}>
          {t('headerDescription')}
        </Text>
      </div>

      <button
        className={styles['header-button']}
        type="button"
        onClick={() => onHandleOpen(false)}
      >
        <CloseIcon />
      </button>
    </header>
  )
}
